<nav class="fixed bottom-0 left-0 w-full card_color shadow-lg z-50 rounded-t-lg block lg:hidden">
  <div class="flex justify-around items-center py-3">
    <!-- Botón Menú -->
    <button class="open-menu-modal flex flex-col items-center gap-0.5" (click)="toggleGlobalMenu(1)">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="text_indigo text-2xl icon icon-tabler icons-tabler-outline icon-tabler-menu-2">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 6l16 0" />
        <path d="M4 12l16 0" />
        <path d="M4 18l16 0" />
      </svg>
      <span class="text-xs text_white font-regular">Menú</span>
    </button>

    <!-- Botón Creditos -->
    <button class="open-login-modal flex flex-col items-center gap-0.5" (click)="toggleGlobalMenu(2)">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="text-2xl text_yellow icon icon-tabler icons-tabler-outline icon-tabler-coins">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z" />
        <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4" />
        <path
          d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z" />
        <path d="M3 6v10c0 .888 .772 1.45 2 2" />
        <path d="M3 11c0 .888 .772 1.45 2 2" />
      </svg>

      <span class="text-xs text_white font-regular">Créditos</span>
    </button>

    <!-- Botón Notificaciones -->
    <button class="open-login-modal flex flex-col items-center gap-0.5 relative"
      (click)="!isPcPlayer ? toggleGlobalMenu(3) : ''" [class.pointer-events]="isPcPlayer"
      [class.opacity-40]="isPcPlayer">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="text-2xl text_green icon icon-tabler icons-tabler-outline icon-tabler-cash">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
        <path d="M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z" />
        <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      </svg>

      <span class="text-xs text_white font-regular">Cajero</span>

      <!-- Bullet de alerta -->
      <span *ngIf="!isPCPlayer && newNotiTransactions"
        class="absolute top-0 right-0 h-2.5 w-2.5 bg_red rounded-full"></span>
    </button>

    <!-- Botón Bonos -->
    <button class="open-login-modal flex flex-col items-center gap-0.5 relative"
      (click)="!isPcPlayer ? toggleGlobalMenu(4) : ''" [class.pointer-events]="isPcPlayer"
      [class.opacity-40]="isPcPlayer">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="text-2xl text_blue icon icon-tabler icons-tabler-outline icon-tabler-gift">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
        <path d="M12 8l0 13" />
        <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
        <path d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5" />
      </svg>

      <span class="text-xs text_white font-regular">Bonos</span>

      <!-- Bullet de alerta -->
      <span *ngIf="!isPCPlayer && newNotiTransactions"
        class="absolute top-0 right-0 h-2.5 w-2.5 bg_red rounded-full"></span>
    </button>

    <!-- Botón Perfil -->
    <button class="open-login-modal flex flex-col items-center gap-0.5" (click)="toggleGlobalMenu(5)">
      <ng-container *ngIf="showSecondProfileMenu; else showPerfil">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EC4899"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
          <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
          <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
        </svg>
        <span class="text-xs text_white font-regular">Lobby</span>
      </ng-container>
      <ng-template #showPerfil>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="text-2xl text_pink icon icon-tabler icons-tabler-outline icon-tabler-user-hexagon">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z" />
          <path d="M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741" />
          <path
            d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
        </svg>
        <span class="text-xs text_white font-regular">Perfil</span>
      </ng-template>
    </button>
  </div>
</nav>

<app-login-modal [showModal]="showLoginModal" (hideModal)="changeLoginModalVisibility($event)" (noAccount)="noAccount()"
  (loginSuccess)="handleLoginSuccess()"></app-login-modal>

<app-create-account-modal [showModal]="showCreateAccountModal"
  (hideModal)="changeShowCreateAccountModal($event)"></app-create-account-modal>

<div class="overflow bg-black absolute w-full h-full z-30 opacity-50" (click)="closeGlobalMenu()"
  *ngIf="showGlobalMenu"></div>

<div *ngIf="showGlobalMenu" id="menuModal"
  class="modal fixed inset-x-0 top-0 bg-black bg-opacity-70 flex justify-center z-40" style="height: calc(100% - 4rem)" (click)="closeOnBackdrop($event)">
  <div (click)="$event.stopPropagation()" id="windowbottom" class="absolute bottom-0 w-full card_color ounded-lg shadow-lg overflow-y-auto" style="max-height: 75%;">
    <!-- Botón de cierre -->
    <button class="close-modal absolute top-4 right-4 text_white hover:text_white text-2xl font-bold"
      (click)="closeGlobalMenu()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="text-2xl text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-x">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 10l4 4m0 -4l-4 4" />
        <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
      </svg>
    </button>

    <app-main-menu-mobile *ngIf="selectedOption === 1" [social_networks]="social_networks" (toggle)="closeGlobalMenu()"
      [show]="true"></app-main-menu-mobile>
    <app-credits-bonos-info *ngIf="selectedOption === 2" [showCredits]="selectedOption === 2"
      [wallet]="wallet"></app-credits-bonos-info>
    <app-modal-cajero *ngIf="selectedOption === 3" [show]="selectedOption === 3" [mobile]="true"
      (toggle)="closeGlobalMenu()"></app-modal-cajero>
    <app-modal-bonus *ngIf="selectedOption === 4" [show]="selectedOption === 4" [mobile]="true"
      (toggle)="closeGlobalMenu()"></app-modal-bonus>
    <app-profile-menu *ngIf="selectedOption === 5" [showProfileMenu]="showProfileMenu" (toggle)="toggleProfile()" [mobile]="true"
      (unlockScroll)="toggleBodyScroll(false)" [isPCPlayer]="isPCPlayer"></app-profile-menu>
  </div>
</div>